<template>
  <div>
    <el-table
    :data="tableData"
    stripe
    :height="tabH">
      <el-table-column
        v-for="col in cols"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        key="edit"
        label="审核"
        width="80">
        <template v-if="col.prop == 'edit'" scope="scope">
          <el-button size="small" @click="edit(scope.row.id)"><i class="el-icon-edit"></i></el-button>
        </template>
      </el-table-column>
      <el-table-column
        key="del"
        label="删除"
        width="80">
        <template v-if="col.prop == 'del'" scope="scope">
          <el-button size="small" @click="del(scope.row.id)"><i class="el-icon-delete"></i></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import examineProblemDlg from '@/components/examineProblemDlg'
  import { deltetPreProblemById } from '@/api/api_examine.js'
  
  export default {
    data () {
      return {
        cols: [
          {
            prop: 'id',
            label: 'id',
            width: 80
          },
          {
            prop: 'type1',
            label: '类别1',
            width: 150
          },
          {
            prop: 'type2',
            label: '类别2',
            width: 150
          },
          {
            prop: 'title',
            label: '标题',
            width: 150
          },
          {
            prop: 'keyword',
            label: '关键词',
            width: 150
          },
          {
            prop: 'amark',
            label: '答案标记',
            width: 150
          },
          {
            prop: 'aformat',
            label: '答案格式',
            width: 150
          },
          {
            prop: 'answer',
            label: '答案',
            width: 150
          }
        ]
      }
    },
    props: ['tableData'],
    computed: {
      tabH () {
        return this.winH - (this.search ? this.search.getHeight() : 80) - 88
      }
    },
    methods: {
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '审核题目',
          message: msg,
          type: type
        })
      },
      edit (id) {
        console.log('examineProblemDlg->edit id = ', id)
        examineProblemDlg({
          isEditData: false,
          dshid: id
        })
      },
      del (id) {
        console.log('delete id=' + id)
        let data = {}
        data.id = id
        deltetPreProblemById(data).then((res) => {
          if (res.data) {
            if (res.data.isOk === true) {
              this.showMsg('成功删除，请刷新更新。', 'info')
            } else {
              this.showMsg('删除待审核题目失败。', 'info')
            }
          } else {
            this.showMsg('删除待审核题目失败', 'info')
          }
        }).catch(err => {
          this.showMsg(`删除待审核题目失败${err}`)
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// prepareProblemTable.vue?677f218a